import React, { useEffect, useState } from 'react';
import { SaatAraligi } from '../../../helpers/saatAraligi';
import { MesaiTalebiService, TalepPersonelDurumu } from '../../../services/MesaiTalebiService';

interface Props {
    tarih: string | undefined
    aralik: SaatAraligi | null
    personelIdleri: string[]
}

const saat = (dk: number) => `${Math.floor(dk / 60)}:${String(dk % 60).padStart(2, '0')}`;

/**
 * Ek mesai talebi formunda seçilen personelin o günkü vardiyası, izni ve uyarıları (İK Faz 3, 03.11.2026).
 * Uyarılar kaydı durdurmaz (izinli kişiyi sunucu yine reddeder). Vardiya saatine denk gelen kısım faturalanmaz.
 */
const TalepPersonelDurumlari = ({ tarih, aralik, personelIdleri }: Props) => {
    const [liste, setListe] = useState<TalepPersonelDurumu[]>([]);
    const anahtar = [tarih, aralik?.baslangic, aralik?.bitis, ...personelIdleri].join('|');

    useEffect(() => {
        if (!tarih || personelIdleri.length == 0) {
            setListe([]);
            return;
        }
        let iptal = false;
        const zamanlayici = setTimeout(async () => {
            try {
                const r = await MesaiTalebiService.personelDurumlari(tarih, aralik?.baslangic ?? null, aralik?.bitis ?? null, personelIdleri);
                if (!iptal && r.isSuccess)
                    setListe(r.data ?? []);
            } catch {
                // Bilgi paneli: hata olursa gösterilmez, kayıt sunucuda yine denetlenir.
            }
        }, 300);
        return () => { iptal = true; clearTimeout(zamanlayici); };
    }, [anahtar])

    if (liste.length == 0)
        return null;

    return (
        <div className='mb-5'>
            <label className='form-label'>Seçilen personelin o günü</label>
            <div className='table-responsive'>
                <table className='table table-row-dashed table-sm align-middle gs-0 gy-2 mb-0 fs-7'>
                    <thead>
                        <tr className='text-muted fw-bold'>
                            <th>Personel</th><th>Vardiya</th><th>Hafta</th><th>Yıllık ek</th><th>Uyarı</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            liste.map(x => (
                                <tr key={x.personnelId}>
                                    <td>{x.personelAdi}</td>
                                    <td>
                                        {x.izinKodu
                                            ? <span className='badge badge-light-success'>{x.izinKodu}</span>
                                            : x.vardiyaKodu
                                                ? <span><b>{x.vardiyaKodu}</b> {x.vardiyaSaati}</span>
                                                : <span className='text-muted'>Çalışma Saatleri</span>}
                                    </td>
                                    <td className={x.haftalikDk > 45 * 60 ? 'text-danger' : undefined}>{saat(x.haftalikDk)}</td>
                                    <td className={x.yillikEkDk > 270 * 60 ? 'text-danger' : undefined}>{saat(x.yillikEkDk)}</td>
                                    <td style={{ whiteSpace: 'normal' }} className={x.uyarilar.length > 0 ? 'text-danger' : 'text-muted'}>
                                        {x.uyarilar.length == 0 ? '–' : x.uyarilar.map((u, i) => <div key={i}>{u}</div>)}
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
            <div className='text-muted fs-8 mt-1'>Uyarılar kaydı durdurmaz. Haftalık sınır 45 saat, yıllık ek mesai sınırı 270 saat (İş Kanunu).</div>
        </div>
    );
}

export default TalepPersonelDurumlari;
